import { mapCurrency } from '@webapp/core/data-access/mappers/mapCurrency'
import { type LegalEntitySummaryWithBaseCurrencyConstructor } from '@webapp/platform/legal-entities/entities/LegalEntitySummaryWithBaseCurrency'
import { type LegalEntitySummaryWithBaseCurrencyApiModel } from '../api-models/LegalEntitySummaryWithBaseCurrencyApiModel'

export const mapLegalEntitySummaryWithBaseCurrencyApiModel = (
  data: LegalEntitySummaryWithBaseCurrencyApiModel
): LegalEntitySummaryWithBaseCurrencyConstructor => ({
  id: data.id,
  uuid: data.uuid,
  name: data.name,
  baseCurrency: mapCurrency(data.base_currency),
})
